<template lang="pug">
#home
	.top-bar
		h1.title Home
		p.version Version: {{ $store.getters.appVersion }}
		p.subtitle Click any record to view details

		//- search will go here
		simple-search(
			state='open'
			placeholder='Search for a record'

			@search='search'
			@close='resetResults'
		)

		.filters

			date-input.date-recorded(
				@click='addFilter( "recorded" )'

				:options='dateRecordedOptions'

				v-model='filters.dateRecorded'
			)

			date-input.date-published(
				@click='addFilter( "published" )'

				:options='datePublishedOptions'

				v-model='filters.datePublished'
			)

			.document-type
				p(@click='openDropdown = !openDropdown') Document Type
				dropdown-filter(
					:options='dropdownOptions'
					:openFilter='openDropdown'
					@filter='addTypeFilter'
				)

	.search-results(v-if='searchResults.length !== 0')

		.card-group

			.card-wrapper(v-for='card in searchResults' :key='card.assetKey')
				comment-card(
					v-if='card.comp === "comment"'
					:card='card'

					@click.native='viewComment( card )'
				)

				viewed-card(
					v-else

					:card='card'
					@click.native='viewAsset( card )'
				)

	.home-container(v-else-if='( !recentlyViewed || Object.keys( recentlyViewed ).length === 0 ) && ( !replies || Object.keys( replies ).length === 0 )')
		h1.section-title Nothing To Show

	.home-container(v-else)

		.comment-replies
			h1.group-title Comment Replies

			.card-group(v-if='!displayedReplies || Object.keys( displayedReplies ).length === 0')
				h1.section-title Nothing To Display

			.card-group(v-else)
				comment-card(
					v-for='card in displayedReplies'
					:card='card'
					:key='card.assetKey'
					@click.native='viewComment( card )'
				)
				.view-more(
					v-if='isMore'
					@click='updateReplies'
				)
					p.spacey View More

		.recently-viewed

			h1.group-title Recently Viewed

			.card-group(v-if='!displayedViewedCards || Object.keys( displayedViewedCards ).length === 0')

				h1.section-title Nothing To Display

			.card-group(
				v-for='( cards, key, index ) in displayedViewedCards'
				:key='index'
				v-else
			)

				h1.date-title {{ cards[0].viewedAt }}

				.card-container

					viewed-card(
						v-for='card in cards'
						:key='card.assetKey'
						v-if='propertyMap[card.type]'

						:card='card'
						@click.native='viewAsset( card )'
					)
</template>

<script>
import {
	_firestore,
} from '@/lib/db';
import { GetComment, GetRepliesWithRange } from '@/lib/db/getReplies';
import { RecentlyViewed } from '@/lib/db/recentlyViewed';
import { SetFirestoreUser } from '@/lib/db/users';
import BM25 from '@/lib/BM25';
import { months } from '@/lib/time';
import {
	clone,
	FormatDate,
	// eslint-disable-next-line no-unused-vars
	Compare,
} from '@/lib/utils';

export default {
	name : 'home',

	data : () => ( {

		searchResults : [],
		query         : '',

		openDropdown : false,
		timerId      : null,

		datePublishedOptions : {
			allowRange  : true,
			defaultText : 'Date Published',
		},

		dateRecordedOptions : {
			allowRange  : true,
			typeDate    : true,
			defaultText : 'Date Recorded',
		},

		dropdownOptions : {
			options : [
				{
					text  : 'Agreements',
					value : 'agreements',
				},
				{
					text  : 'Facilities',
					value : 'canals',
				},
				{
					text  : 'Jobs',
					value : 'jobs',
				},
				{
					text  : 'Parcels',
					value : 'parcels',
				},
				{
					text  : 'Permits',
					value : 'permits',
				},
				{
					text  : 'Requests',
					value : 'requests',
				},
				{
					text  : 'Reviews',
					value : 'reviews',
				},
			],
		},
		dropdownValue : '',

		propertyMap : {
			jobs : {
				assetKey    : 'jobsKey',
				date        : 'dateCreated',
				description : 'summary',
				subText     : 'manager',
				title       : 'category',
			},
			agreements : {
				assetKey    : 'agreementsKey',
				date        : 'createdAt',
				description : 'recordOwner',
				subText     : 'agreementCategory.description', // ! THIS IS JUST A PLACEHOLDER, NOT SURE WHAT THE ACTUAL VALUE WILL BE, ASK TIM ! //
				title       : 'type',
			},
			facilities : {
				assetKey    : 'facilitiesKey',
				date        : 'createdAt',
				description : 'status',
				subText     : 'locationDescription',
				title       : 'name',
			},
			reviews : {
				assetKey    : 'reviewKey',
				date        : 'dateReceived',
				description : 'comments',
				subText     : 'responseBy',
				title       : 'reviewsType.description',
			},
			requests : {
				assetKey    : 'actionRequestsKey',
				date        : 'createdAt',
				description : 'summary',
				subText     : 'requestingParty',
				title       : 'rulingAction.description',
			},
			permits : {
				assetKey    : 'permitsKey',
				date        : 'dateIssued',
				description : 'summary',
				subText     : 'permittee',
				title       : 'issuedBy',
			}
			// TODO we're going to have define the rest of the
			// TODO asset maps right here
		},

		filters : {
			dateRecorded  : null,
			datePublished : null,
			documentType  : null,
		},

		recentlyViewed : [],
		replies        : [],

		displayedReplies : [],

		isMore : true, // indicator for if there is more replies to load

		replyPaginationIndex     : 1,
		replyPaginationIncrement : 10,
		firstReplyPullAmount     : 50,

	} ),

	computed : {

		user() {
			return this.$store.getters.postgresUser;
		},

		formattedCards() {

			// for each prop you're going to have to do a multitude of things
			// the first being that you're going to have to get the first layer's
			// data. After you get the first, you continue going down the list of
			// our nested props until you finally get the data you want.
			// CG - 'index' taken out of the arrow function as the last param below since it's not used.
			const getNestedData = ( props, asset ) => props.reduce( ( parent, key, ) => {

				if ( !parent || parent === 'N/A' ) {
					return 'N/A';
				}

				const dataLayer = parent[key];
				if ( !dataLayer ) {
					return 'N/A';
				}

				return dataLayer;

			}, asset );

			return this.recentlyViewed.map( ( card ) => {

				const formattedCard = {
					type : card.type,
				};

				// in here we're going to figure out what record it is by using
				// the propertyMap. Instead of having the asset property we're
				// going to replace the `asset` property with all of the card
				// properties.

				const propertyMap = this.propertyMap[card.type];
				const properties  = Object.keys( propertyMap );

				properties.forEach( ( propertyKey ) => {

					const property = propertyMap[propertyKey];

					if ( property.includes( '.' ) ) {

						// you're going to have to split this property up
						// by where the periods are, so that way you can
						// go into nested properties. "facility.name" -> ["facility", "name"]
						const nestedProps = property.split( '.' );
						const nestedData  = getNestedData( nestedProps, card.asset );

						formattedCard[propertyKey] = nestedData;

						return;

					}

					if ( !card.asset || !card.asset[property] ) {
						formattedCard[propertyKey] = 'N/A';
						return;
					}

					formattedCard[propertyKey] = card.asset[property];
				} );

				return formattedCard;
			} );
		},

		filteredViewedCards() {

			const { formattedCards } = this;

			const { datePublished, dateRecorded, documentType } = this.filters;

			if ( !formattedCards || !formattedCards.length ) {
				return;
			}

			// if no filters are applied, return all cards
			if ( !datePublished && !dateRecorded && !documentType ) {
				// eslint-disable-next-line consistent-return
				return formattedCards;
			}

			const typeMap = {
				agreements : false,
				jobs       : false,
				facilities : false,
				permits    : false,
			};

			if ( documentType ) {
				typeMap[documentType] = true;
			}

			const filteredRecords = formattedCards.filter( ( a ) => {

				const dateRangeCheck = ( dateRange, val ) => {

					const dateVal = new Date( val );

					if ( !dateRange ) {
						return true;
					}

					if ( typeof dateRange === 'object' ) {
						// if it's an object we can look to see if the given value
						// is within the after and before dates.

						const valTimeStamp = dateVal.getTime();

						const beforeTimeStamp = new Date( dateRange.before ).getTime();
						const afterTimeStamp  = new Date( dateRange.after ).getTime();

						const isBefore = beforeTimeStamp > valTimeStamp;
						const isAfter  = afterTimeStamp < valTimeStamp;

						const result = isBefore && isAfter;

						return result;
					}

					// if dateRange wasn't an object we can assume that it was either
					// a string, or a null value

					if ( typeof dateRange === 'string' ) {

						const ISODateRange = new Date( dateRange );

						const month = ISODateRange.getUTCMonth() + 1;
						const day   = ISODateRange.getUTCDate();
						const year  = ISODateRange.getUTCFullYear();

						const stringDateRange = `${month}/${day}/${year}`;

						const formattedVal  = FormatDate( dateVal, 'MM/DD/YYYY' );
						const formattedDate = FormatDate( stringDateRange, 'MM/DD/YYYY' );

						return formattedDate === formattedVal;

					}

					// we can assume our dateRange is an unsupported value if
					// it's come this far down our function
					return true;

				};

				// figure out if it's within the datePublished range
				const isInPublishedRange = dateRangeCheck( datePublished, a.date );

				// figure out if it's within the dateRecorded range
				const isInRecordedRange  = dateRangeCheck( dateRecorded, a.viewedAt );

				// figure out if it's within the given documentTypes
				let isValidType = true;

				// * Here's what I want to do. I think if I turn our "documentType" array, * //
				// * into some sort of an object map that looks something like:            * //

				// ? {
				// ?   agreements : true,
				// ?   jobs       : true,
				// ?   facilities : true,
				// ?   permits    : true,
				// ? }

				// * Then we can save the 4 iterations of our document types for each record,  * //
				// * by seeing if the document type is active. The way the map would work is,  * //
				// * wherever we define our "documentType" variable, we would go through that  * //
				// * array once, and whatever types are active, we'll go ahead and update them * //
				// * in our map accordingly. So an example of this would be:                   * //

				// - this.documentType
				// ? [ 'agreements' ]

				// - Map
				// ? {
				// ?   agreements : true,
				// ?   jobs       : false,
				// ?   facilities : false,
				// ?   permits    : false,
				// ? }

				if ( documentType && !typeMap[a.type] ) {
					isValidType = false;
				}

				return ( isInPublishedRange && isInRecordedRange && isValidType );

			} );

			// eslint-disable-next-line consistent-return
			return filteredRecords;
		},

		displayedViewedCards() {

			const { filteredViewedCards } = this;

			if ( !filteredViewedCards || !filteredViewedCards.length ) {
				return [];
			}

			const groupedCards = filteredViewedCards.reduce( ( formattedCards, card ) => {

				const docDate = card.viewedAt;

				if ( !formattedCards[docDate] ) {
					formattedCards[docDate] = []; // eslint-disable-line
				}

				formattedCards[docDate].push( card );

				return formattedCards;

			}, {} );

			const groupedKeys = Object.keys( groupedCards );

			const displayedCards = groupedKeys.reduce( ( newArr, key ) => {

				newArr.push( groupedCards[key] );

				return newArr;

			}, [] );

			displayedCards.sort( ( a, b ) => {
				const aTimeStamp = new Date( a[0].viewedAt ).getTime();
				const bTimeStamp = new Date( b[0].viewedAt ).getTime();

				return bTimeStamp - aTimeStamp;
			} );

			return displayedCards;

		},

	},

	watch : {

		user : {
			immediate : true,
			handler( user ) {

				if ( user && user.uid ) {
					this.updateRecentlyViewed();
					this.updateReplies();

					this.clearNotifications();
				}
			}
		},

	},

	methods : {

		clearNotifications() {

			const { user } = this;

			const newUser = clone( user );

			if ( newUser.notificationCount === 0 ) {
				return;
			}

			newUser.notificationCount = 0;

			SetFirestoreUser( newUser, newUser.uid )
				.then( () => {
					if ( newUser.usersKey ) {
						return;
					}

					this.$store.commit( 'updateUser', newUser );
				} );

		},

		addTypeFilter( type ) {
			this.filters.documentType = null;

			if ( type === '' ) {
				return;
			}

			this.filters.documentType = type.toLowerCase();

		},

		setTimer() {
			this.timerId = window.setTimeout( () => {
				this.openDropdown = '';
			}, 400 );
		},

		clearTimer() {
			if ( this.timerId !== null ) {
				window.clearTimeout( this.timerId );
			}
		},

		resetResults() {

			if ( !this.query ) {
				this.searchResults = [];
			}
		},

		search( query ) {
			this.searchResults = [];
			this.query         = query;

			const { formattedCards } = this;

			if ( !query || query.length === 0 || /^\s$/g.test( query ) ) {
				return;
			}

			const allRecords = formattedCards.concat( this.replies );

			allRecords.forEach( ( record, index ) => {

				if ( record.comment ) {
					// eslint-disable-next-line no-param-reassign
					record.comp = 'comment';
				}

				// eslint-disable-next-line no-param-reassign
				record.uniqueKey = `_${index}`;
			} );

			const recordIndex = new BM25();

			recordIndex.index( allRecords, {
				uniqueKey : 'uniqueKey',
			} );

			this.searchResults = recordIndex.search( query );
		},

		updateRecentlyViewed( firebaseQuery ) {

			const update = ( documents ) => {

				// first things first is we need to get all of the cards grouped by when they were viewed
				this.recentlyViewed = documents.docs.reduce( ( total, current ) => {

					const currentDoc = current.data();
					const docDate    = currentDoc.viewedAt.toDate();
					const month      = new Date( docDate ).getMonth();
					const year       = new Date( docDate ).getFullYear();
					const day        = new Date( docDate ).getDate();
					// const key        = `${months[month]} ${day}, ${year}`;
					const formattedDate = `${months[month]} ${day}, ${year}`;

					currentDoc.viewedAt = formattedDate;

					// if ( !total[key] ) {
					// 	total[key] = []; // eslint-disable-line
					// }

					// total[key].push( currentDoc );

					total.push( currentDoc );

					return total;

				}, [] );

			};

			if ( firebaseQuery ) {
				firebaseQuery()
					.then( documents => update( documents ) );
				return;
			}

			RecentlyViewed()
				.then( documents => update( documents ) );


		},

		updateReplies() {

			const { firstReplyPullAmount, replyPaginationIndex, replyPaginationIncrement } = this;

			// to clarify this is not the first value in replies but
			// rather is what our starting index is going to be for
			// our next API call.
			let start = this.replies[this.replies.length - 1];
			start = start ? start.id : undefined;

			let end  = ( ( replyPaginationIndex * replyPaginationIncrement ) + replyPaginationIncrement );

			if ( start === undefined ) {
				end = firstReplyPullAmount;
			}

			GetRepliesWithRange( start, end, ( replies ) => {

				this.replies = replies;

				// set the displayed replies
				this.setDisplayedReplies();

				// increase the pagination index so that next time this function
				// runs it gets the next set of replies
				this.replyPaginationIndex += 1;
			} );

		},

		setDisplayedReplies() {

			const { replies, replyPaginationIndex, replyPaginationIncrement } = this;

			if ( !replies ) {
				return;
			}

			const displayedReplies = [];

			let end = ( replyPaginationIndex * replyPaginationIncrement );

			if ( end >= this.replies.length ) {
				this.isMore = false;

				end = this.replies.length;
			}

			for ( let i = 0; i < end; i += 1 ) {
				displayedReplies.push( replies[i] );
			}

			this.displayedReplies = displayedReplies;

		},

		// this is a recursive function
		viewComment( comment ) {

			const { sectionId, commentId } = comment;
			const [assetName, assetKey] = sectionId.split( '-' );

			const assetRoutesMap = {
				'agreements' : 'agreements',
				'jobs'       : 'jobs',
				'permits'    : 'permits',
				'facilities' : 'canals',
				'reviews'    : 'developer-utility-reviews',
				'requests'   : 'engineering-action-requests'
			};

			GetComment( sectionId, commentId )
				.then( ( doc ) => {

					// Display error message and delete reply
					if ( !doc.exists ) {
						this.$store.dispatch( 'displayState', {} )
							.then( ( stateIndicator ) => {
								stateIndicator.fail( { header : 'Reply no longer exists', message : '' } );

								setTimeout( () => {
									this.$store.dispatch( 'removeDisplayState', stateIndicator.index );
								}, 2500 );

							} )
							.then( () => _firestore.collection( 'users' )
								.doc( this.user.uid )
								.collection( 'replies' )
								.doc( commentId )
								.delete() );

						return;
					}

					this.$router.push( {
						name  : assetRoutesMap[assetName],
						query : {
							key : assetKey,
							commentId,
						}
					} );
				} );

		},

		async viewAsset( asset ) {
			const routeOf = {
				jobs       : 'jobs',
				facilities : 'canals',
				agreements : 'agreements',
				permits    : 'permits',
				requests   : 'engineering-action-requests',
				reviews    : 'developer-utility-reviews',
			};

			this.$router.push( {
				name  : routeOf[asset.type],
				query : {
					key : asset.assetKey,
				}
			} );
		},

	},

	components : {
		DateInput         : () => import( '@/components/form-inputs/DateInput' ),
		DropdownFilter    : () => import( '@/components/DropdownFilter' ),
		SimpleSearch      : () => import( '@/components/SimpleSearch' ),
		CommentCard       : () => import( '@/components/CommentCard' ),
		ViewedCard        : () => import( '@/components/ViewedCard' ),
		AssetSlideOut     : () => import( '@/components/slide-outs/AssetSlideOut' ),
		Agreements        : () => import( '@/components/slide-outs/agreements' ),
		FacilitieSlideOut : () => import( '@/components/slide-outs/facilities' ), // leave the misspelling, there is a bug in the code that determines this name.
		Facilities        : () => import( '@/components/slide-outs/facilities' ),
		JobSlideOut       : () => import( '@/components/slide-outs/jobs' ),
		Parcels           : () => import( '@/components/slide-outs/parcels' ),
		Permits           : () => import( '@/components/slide-outs/permits' ),
		Requests          : () => import( '@/components/slide-outs/requests' ),
		Reviews           : () => import( '@/components/slide-outs/reviews' ),
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#home {
	width: 100%;
	height: 100vh;
	overflow-y: scroll;

	> .top-bar {
		display: flex;
		flex-flow: column;
		justify-content: space-between;
		padding: 25px 45px 0px 55px;
		flex: 0 0 auto;
		position: relative;
		z-index: 10;
		.title {
			color: $input-color;
		}
		.version {
			color: $color-primary;
			position: absolute;
			right: 0;
			top: 0;
		}
		.subtitle {
			color: $color-primary;
		}

		.simple-search {
			flex: auto;
			margin-top: 15px;
			max-width: 480px;

			.main-search {
				background: linear-gradient(70.26deg, rgba(168, 180, 190, 0.272) 0%, rgba(168, 180, 190, 0.172) 100%);
				box-shadow: none;

				.icon-search {
					color: $input-color;
				}

				input {
					color: $input-color;
					font-weight: 400;

					&::placeholder {
						color: inherit;
					}
				}
			}
		}

		.filters {
			display: flex;
			flex-flow: row;
			margin-top: 15px;

			.date-input {
				box-shadow: none;
				margin-right: 45px;

				.main-display {
					font-weight: 400;
				}
			}

			.document-type {
				cursor: pointer;
				display: flex;
				flex-flow: row nowrap;
				align-items: center;

				.dropdown-filter {
					margin-left: 30px;

					.icon {

						.clickable-arrow {
							margin-left: 0;

							&.open {

								&::before {
									left: 50%;
									transform: translate3d(-50%, -50%, 0) rotate(-45deg);
								}

								&::after {
									left: 50%;
									transform: translate3d(-50%, -50%, 0) rotate(45deg);
								}
							}

							&::after {
								transform: translate(calc(-50% + 2px), -50%) rotate(45deg);
							}
						}
					}

					.dropdown-body {
						transform: translate(-50%, 10px)!important;
					}

					.selected {
						margin: 0 2px;
					}
				}
			}
		}
	}

	.search-results {
		margin-left: 35px;
		padding-top: 35px;

		.card {
			border-radius: 15px;
			box-shadow: 0px 4px 24px rgba(80, 96, 110, 0.2), 0px 2px 5px rgba(80, 96, 110, 0.15);
			overflow: hidden;
			cursor: pointer;
			width: 275px;
		}

		.card-group {
			display: flex;
			flex-flow: row wrap;
			justify-content: flex-start;

			.card {
				margin: 0 15px 35px 15px;
			}
		}
	}

	.home-container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding-top: 35px;

		>.section-title {
			margin-left: 55px;
			font-weight: 500;
			font-size: 24px;
			-webkit-font-smoothing: antialiased;
		}

		h1 {
			color: $color-secondary;
		}

		.card {
			border-radius: 15px;
			box-shadow: 0px 4px 24px rgba(80, 96, 110, 0.2), 0px 2px 5px rgba(80, 96, 110, 0.15);
			overflow: hidden;
			cursor: pointer;
			max-width: 275px;
			min-width: 220px;
		}

		.group-title {
			color: $color-primary;
			font-size: 24px;
			font-weight: 400;
			margin-left: 55px;
			margin-bottom: 30px;
		}

		.comment-replies {
			width: 100%;

			.card-group {
				margin-left: 35px;
				margin-bottom: 25px;
				display: flex;
				flex-flow: row wrap;
				justify-content: flex-start;

				.date-title, .section-title {
					margin-left: 20px;
					margin-bottom: 25px;
					font-weight: 500;
					font-size: 20px;
					-webkit-font-smoothing: antialiased;
				}

				.date-title, .section-title {
					margin-left: 20px;
					margin-bottom: 25px;
					font-weight: 500;
					font-size: 20px;
					-webkit-font-smoothing: antialiased;
				}

				.card {
					margin: 0 30px 35px 0px;
					flex-basis: 20%;

					&:first-of-type {
						margin-left: 0;
					}

					.author-info {
						padding-top: 12px;
						padding-bottom: 12px;
					}
				}

				.view-more {
					width: 100%;
					text-align: center;
					cursor: pointer;
				}
			}
		}

		.recently-viewed {
			width: 100%;

			.card-group {
				margin-bottom: 45px;

				.date-title, .section-title {
					margin-left: 55px;
					margin-bottom: 25px;
					font-weight: 500;
					font-size: 20px;
					-webkit-font-smoothing: antialiased;
				}

				.card-container {
					display: flex;
					flex-flow: row wrap;
					justify-content: flex-start;
					width: 100%;
					padding-left: 20px;

					.card {
						margin: 0 15px 35px 15px;
						flex-basis: 30%;
					}
				}
			}
		}
	}
}
</style>
